<div [formGroup]="form" *ngIf="form">
  <ion-item>
    <bones-form-label [item]="item"></bones-form-label>
    <ion-textarea [formControlName]="item.name" [rows]="item.textarea.rows" [readonly]="item.readonly"></ion-textarea>
  </ion-item>
</div>
